import LoginPage from './pages/login/LoginPage';
import AdminList from './pages/admin/AdminList';
import UserList from './pages/user/UserList';
import LogoutPage from './pages/logout/LogoutPage';
import BoostList from './pages/manage-boosts/BoostList';
import UserBoostsList from './pages/manage-boosts/user/UserBoostsList';
import TicketList from './pages/tickets/TicketLists';
import TicketDetailPage from './pages/tickets/TicketDetailPage';
import TrendingPairsList from './pages/trends/TrendingPairsList';
import HowToUse from './pages/howToUse/HowToUse';
import FeedbackTicketsList from './pages/feedback/FeedbackTicketsList';
import FeedbackTicketDetailPage from './pages/feedback/FeedbackTicketDetailPage';
import FriendReferrals from './pages/referrals/FriendReferrals';
import OfferRequestList from './pages/offer/OfferRequestList';
import OfferRequestDetail from './pages/offer/OfferRequestDetail';
import AnnouncementList from './pages/announcements/AnnouncementList';
const routes = [
    {
        name: 'LoginPage',
        path: '/',
        component: LoginPage
    },
    {
        name: 'Announcements',
        path: '/announcements',
        component: AnnouncementList
    },
    {
        name: 'LoginPage',
        path: '/login',
        component: LoginPage
    },
    {
        name: 'AdminListPage',
        path: '/admin-list',
        component: AdminList
    },
    {
        name: 'UserListPage',
        path: '/user-list',
        component: UserList
    },
    {
        name: 'TrendsListPage',
        path: '/trending-pairs',
        component: TrendingPairsList
    },
    {
        name: 'LogoutPage',
        path: '/logout',
        component: LogoutPage
    },
    {
        name: 'BoostList',
        path: '/boost-list',
        component: BoostList
    },
    {
        name: 'UserBoostsList',
        path: '/user-boost-list',
        component: UserBoostsList
    },
    {
        name: 'TicketList',
        path: '/tickets',
        component: TicketList
    },
    {
        name: 'TicketDetail',
        path: '/tickets/:id',
        component: TicketDetailPage,
    },
    {
        name: 'FriendReferrals',
        path: '/friend-referrals',
        component: FriendReferrals,
    },
    {
        name: 'FeedbackTickets',
        path: '/admin/feedback-tickets',
        component: FeedbackTicketsList,
    },
    {
        name: 'FeedbackTicketDetail',
        path: '/admin/feedback-tickets/:threadId',
        component: FeedbackTicketDetailPage,
    },
    {
        name: 'Teklif Talepleri',
        path: '/admin/offer-requests',
        component: OfferRequestList,
    },
    {
        name: 'Teklif Talebi Detay',
        path: '/admin/offer-requests/:id',
        component: OfferRequestDetail,
    },
    {
        name: 'HowToUse',
        path: '/how-to-use',
        component: HowToUse,
    }
    //{
    //    name: 'NotFound',
    //    module: '/foreigntrade',
    //    path: '*',
    //    component: NotFound,
    //}
];

export default routes;
